import { useState } from "react";
import { appointment } from "@solimat/solimat-web-endpoint";
import useCheckStatusAppointment from "../../hooks/useCheckStatusAppointment";
import Moment from "moment";
import useDecode from "../../hooks/useDecode";
import moment from "moment";

export interface IDoctor {
  nombre: string;
}
export interface ICentro {
  centroId: string;
  nombre: string;
  descripcion: string;
  codigoPostal: string;
  provincia: string;
  localidad: string;
  tipoCalle: string;
  nombreCalle: string;
  numeroCalle: string;
  letra: string;
  piso: string;
  latitud: number;
  longitud: number;
  telefono: string;
}
export interface INextAppointment {
  id: string;
  citaId: string;
  userId: string;
  personaId: string;
  fecha: string;
  mensaje: string;
  nombrePrueba: string;
  especialidad: string;
  tipoActividad: string;
  estado: string;
  realizada: boolean;
  reprogramada: boolean;
  incomparecencia: boolean;
  doctor: IDoctor;
  centro: ICentro;
  linkVideoConsulta: string;
}

const useGetAllAppointmentsByUserId = () => {
  const BASE_URL = import.meta.env.VITE_REACT_APP_CITAS_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_CITAS_KEY || "";
  const apiAppointment = new appointment.AppointmeService(
    BASE_URL,
    FUNCTIONS_KEY,
  );
  const [statusRes, setStatusRes] = useState(0);
  const [allAppointmentsByUserId, setAllAppointmentsByUserId] = useState();
  const [
    successGetAllAppointmentsByUserId,
    setSuccessGetAllAppointmentsByUserId,
  ] = useState(false);
  const [
    loadingGetAllAppointmentsByUserId,
    setLoadingGetAllAppointmentsByUserId,
  ] = useState(false);
  const [errorGetAllAppointmentsByUserId, setErrorGetAllAppointmentsByUserId] =
    useState(false);
  const [crudeAppointmentsScheduled, setCrudeAppointmentsScheduled] = useState(
    [],
  );
  const [crudeAppointmentsAnother, setCrudeAppointmentsAnother] = useState([]);
  const { checkStatusAppointment } = useCheckStatusAppointment();
  const tokenResponse = useDecode("token");
  const userId = tokenResponse && tokenResponse.extension_id;

  const EMPTY_APPOINTMENT: INextAppointment = {
    id: "",
    citaId: "",
    userId: "",
    personaId: "",
    fecha: "",
    mensaje: "",
    nombrePrueba: "",
    especialidad: "",
    tipoActividad: "",
    estado: "",
    realizada: true,
    reprogramada: false,
    incomparecencia: false,
    doctor: { nombre: "Doctor" },
    centro: {
      centroId: "",
      nombre: "",
      descripcion: "",
      codigoPostal: "",
      provincia: "",
      localidad: "",
      tipoCalle: "",
      nombreCalle: "",
      numeroCalle: "",
      letra: "",
      piso: "",
      latitud: 0,
      longitud: 0,
      telefono: "",
    },
    linkVideoConsulta: "",
  };
  // DEV-ONLY: set to true to preview the card with appointment data
  const USE_MOCK = false;
  const MOCK_APPOINTMENT: INextAppointment = {
    id: "mock-001",
    citaId: "cita-001",
    userId: "user-001",
    personaId: "persona-001",
    fecha: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(), // en 2 días
    mensaje: "",
    nombrePrueba: "Revisión traumatológica",
    especialidad: "Traumatología",
    tipoActividad: "Consulta",
    estado: "Pendiente",
    realizada: false,
    reprogramada: false,
    incomparecencia: false,
    doctor: { nombre: "Dra. L. Romero" },
    centro: {
      centroId: "centro-001",
      nombre: "Hospital San José de Solimat",
      descripcion: "Hospital San José de Solimat",
      codigoPostal: "02006",
      provincia: "Albacete",
      localidad: "Albacete",
      tipoCalle: "C/",
      nombreCalle: "Hermanos Falcó",
      numeroCalle: "37",
      letra: "",
      piso: "",
      latitud: 38.9942,
      longitud: -1.8564,
      telefono: "967511417",
    },
    linkVideoConsulta: "",
  };
  const [nextAppointment, setNextAppointment] =
    useState<INextAppointment>(EMPTY_APPOINTMENT);

  const [nextAppointments, setNextAppointments] = useState<INextAppointment[]>(
    [],
  );
  const [resolved, setResolved] = useState(false);
  const [hasAppt, setHasAppt] = useState(false);

  const formatAppointments = (arrData: any) => {
    let formatedAppos = arrData.map((appo: any) => {
      return {
        ...appo,
        datetime: appo.fecha,
        formated_status: checkStatusAppointment(appo.estado),
        formated_start: Moment(appo.fecha).format("DD/MM/YYYY"),
        formated_hour: Moment(appo.fecha).format("HH:mm"),
        comment:
          appo.communication_id !== null &&
          appo.communication_id !== "" &&
          appo.communication_id !== undefined
            ? "SI"
            : "NO",
      };
    });

    return formatedAppos;
  };

  const getAllAppointmentsByUserId = (_cb?: () => void) => {
    setLoadingGetAllAppointmentsByUserId(true);

    // 1.GET APPOINTMENTS
    apiAppointment
      .getAllAppointmentByUserId(userId)
      .then((res: any) => {
        setStatusRes(res.status);
        setAllAppointmentsByUserId(res.data.rows);
        setSuccessGetAllAppointmentsByUserId(true);
        setLoadingGetAllAppointmentsByUserId(false);
        setErrorGetAllAppointmentsByUserId(false);
        // 2.FILTER APPOINTMENTS
        let arrCrudeAppointmentsScheduled =
          res.status === 204
            ? []
            : res.data.rows.filter(
                // (a: any) => Moment(a.fecha).format()>= Moment('').format() compara con hora
                (a: any) =>
                  parseInt(
                    Moment(a.fecha).format("Y MM DD").replace(/\s+/g, ""),
                  ) >= parseInt(Moment().format("Y MM DD").replace(/\s+/g, "")),
              );
        let arrCrudeAppointmentsAnother =
          res.status === 204
            ? []
            : res.data.rows.filter(
                // (a: any) => Moment(a.fecha).format()<= Moment('').format() compara con hora
                (a: any) =>
                  parseInt(
                    Moment(a.fecha).format("Y MM DD").replace(/\s+/g, ""),
                  ) < parseInt(Moment().format("Y MM DD").replace(/\s+/g, "")),
              );
        //  let toDay = parseInt(Moment().format('Y MM DD').replace(/\s+/g, ''))
        //  console.log(toDay < 20220505)
        // 3.FORMAT APPOINTMENTS
        arrCrudeAppointmentsScheduled = formatAppointments(
          arrCrudeAppointmentsScheduled,
        );
        arrCrudeAppointmentsAnother = formatAppointments(
          arrCrudeAppointmentsAnother,
        );

        // 4.SET CRUDE APPOINTMENTS: scheduled & another
        setCrudeAppointmentsScheduled(arrCrudeAppointmentsScheduled);
        setCrudeAppointmentsAnother(arrCrudeAppointmentsAnother);
      })
      .catch((err: any) => {
        console.log(err);
        setSuccessGetAllAppointmentsByUserId(false);
        setLoadingGetAllAppointmentsByUserId(false);
        setErrorGetAllAppointmentsByUserId(true);
      });
  };

  const getNextAppointment = (userId: string) => {
    if (USE_MOCK) {
      setNextAppointment(MOCK_APPOINTMENT);
      setResolved(true);
      return;
    }
    if (!userId) return;
    apiAppointment
      .getNextAppointment(userId)
      .then((res: any) => {
        if (res.data?.rows?.length) {
          setNextAppointment(res.data.rows[0]);
          setHasAppt(true);
        }
        setResolved(true);
      })
      .catch((err: any) => {
        console.log(err);
        setResolved(true);
        setHasAppt(false);
      });
  };

  const getNextAppointmentsByUserId = (userId: string) => {
    if (!userId) return;
    apiAppointment
      .getAllAppointmentByUserId(userId)
      .then((res: any) => {
        if (res.data?.rows?.length) {
          const futuras = ((res.data?.rows || []) as INextAppointment[]).filter(
            (c) => new Date(c.fecha) > new Date(),
          );
          setNextAppointments(futuras);
        }
        setResolved(true);
      })
      .catch((err: any) => {
        console.log(err);
        setResolved(true);
        setHasAppt(false);
      });
  };

  return {
    getAllAppointmentsByUserId,
    getNextAppointmentsByUserId,
    getNextAppointment,
    allAppointmentsByUserId,
    crudeAppointmentsScheduled,
    crudeAppointmentsAnother,
    successGetAllAppointmentsByUserId,
    loadingGetAllAppointmentsByUserId,
    errorGetAllAppointmentsByUserId,
    statusRes,
    nextAppointment,
    resolved,
    hasAppt,
  };
};

export default useGetAllAppointmentsByUserId;
